module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzA0NyIgaGVpZ2h0PSI5NzkiIHZpZXdCb3g9IjAgMCAzMDQ3IDk3OSI+PGRlZnM+PHBhdGggaWQ9IjF4MTdhIiBkPSJNLTE0Mi45NjYgODg1LjMwM3M4NDUuMTUgMzc0LjYxOCAyMDcyLjM2IDBjMTIyNy4yMTItMzc0LjYxNyAwIDg3Ni44NzIgMCA4NzYuODcycy0xMTA4LjI5My0yMzAuODkyLTIwNzIuMzYgMGMtOTY0LjA2OCAyMzAuODkzIDAtODc2Ljg3MiAwLTg3Ni44NzJ6Ii8+PC9kZWZzPjxnPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU3MiAtODE1KSI+PHVzZSBmaWxsPSIjZmVmN2VkIiB4bGluazpocmVmPSIjMXgxN2EiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/participation-bg-shape@mn.svg
// module id = r+Zo
// module chunks = 0